import React, { useEffect, useState } from 'react';
import { Wifi, WifiOff, RefreshCw, CheckCircle2 } from 'lucide-react';
import { getQueueCount } from '../lib/offline';
import { syncQueue, onSyncChange } from '../lib/sync';

const OfflineIndicator = () => {
  const [online, setOnline] = useState(typeof navigator !== 'undefined' ? navigator.onLine : true);
  const [pending, setPending] = useState(0);
  const [syncing, setSyncing] = useState(false);
  const [justSynced, setJustSynced] = useState(false);

  const refreshCount = async () => {
    try { setPending(await getQueueCount()); } catch (e) { /* noop */ }
  };

  useEffect(() => {
    const onOnline = () => { setOnline(true); refreshCount(); };
    const onOffline = () => setOnline(false);
    window.addEventListener('online', onOnline);
    window.addEventListener('offline', onOffline);
    refreshCount();
    const interval = setInterval(refreshCount, 4000);
    const off = onSyncChange((s) => {
      if (s.syncing) setSyncing(true);
      else {
        setSyncing(false);
        if (s.synced > 0) {
          setJustSynced(true);
          setTimeout(() => setJustSynced(false), 2500);
        }
        refreshCount();
      }
    });
    return () => {
      window.removeEventListener('online', onOnline);
      window.removeEventListener('offline', onOffline);
      clearInterval(interval);
      off();
    };
  }, []);

  const triggerSync = () => { syncQueue(); };

  // Hide if online with no pending
  if (online && pending === 0 && !justSynced) return null;

  return (
    <div className="fixed top-3 left-1/2 -translate-x-1/2 z-[1000] max-w-[440px] w-[calc(100%-1.5rem)] px-2 fade-in">
      <div className={`rounded-full px-4 py-2 shadow-lg flex items-center gap-2.5 backdrop-blur-md border text-[12.5px] ${
        !online ? 'bg-[#1c1c1c]/95 text-[#f8f6f1] border-[#2a2a2a]' :
        justSynced ? 'bg-[#15803d]/95 text-white border-[#15803d]' :
        'bg-[#fef3c7]/95 text-[#92400e] border-[#fde68a]'
      }`}>
        {!online ? (
          <>
            <WifiOff size={14}/>
            <span className="font-medium">Sin conexión</span>
            {pending > 0 && <span className="text-[#a8a397]">· {pending} pendiente{pending !== 1 ? 's' : ''}</span>}
          </>
        ) : justSynced ? (
          <>
            <CheckCircle2 size={14}/>
            <span className="font-medium">Sincronizado</span>
          </>
        ) : (
          <>
            <Wifi size={14}/>
            <span className="font-medium">{pending} captura{pending !== 1 ? 's' : ''} sin enviar</span>
            <button onClick={triggerSync} disabled={syncing} className="ml-auto inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-[#1c1c1c] text-[#f8f6f1] text-[11px] font-medium disabled:opacity-60">
              <RefreshCw size={11} className={syncing ? 'animate-spin' : ''}/> {syncing ? 'Sincronizando' : 'Sincronizar'}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default OfflineIndicator;
